import { mergeClasses } from "@lib/css"

import type { SVGProps } from "react"

export function PureLogo(props: SVGProps<SVGSVGElement>) {
  const { className, ...otherProps } = props

  const defaultClasses = "w-[56.94px] text-black tablet:w-[125px] tablet:h-8.5"
  const classes = mergeClasses(defaultClasses, className)

  return (
    <svg
      viewBox="0 0 106 28"
      fill="none"
      preserveAspectRatio="none"
      className={classes}
      {...otherProps}
    >
      <path
        d="M46.5841 0H43.26C42.5906 0 42.5906 0.0693238 42.5906 0.73929V16.703C42.5906 20.9769 40.9516 23.5412 37.2812 23.5412C33.6109 23.5412 31.9719 20.9538 31.9719 16.703V0.73929C31.9719 0.0693238 31.9719 0 31.2794 0H28.1169C27.4244 0 27.332 0.0693238 27.332 0.73929V16.934C27.332 24.4884 31.3256 28 37.3043 28C43.2831 28 47.2766 24.4884 47.2766 16.934V0.73929C47.2535 0.0924261 47.2535 0 46.5841 0Z"
        fill="currentColor"
      />
      <path
        d="M8.49492 0H0.669435C-1.43095e-06 0 0 0.0693238 0 0.73929V26.5907C0 27.2607 -1.43095e-06 27.33 0.669435 27.33H3.83195C4.45521 27.33 4.52447 27.2607 4.52447 26.5907V16.6567H8.47183C14.3352 16.6567 18.3287 14.3465 18.3287 8.29373C18.3518 2.24093 14.3583 0 8.49492 0ZM8.81809 12.3597H4.54755V4.29702H8.81809C11.6805 4.29702 13.8273 5.42905 13.8273 8.29373C13.8273 11.1584 11.6574 12.3597 8.81809 12.3597Z"
        fill="currentColor"
      />
      <path
        d="M105.032 23.0561H94.7139V15.6172H104.132C104.709 15.6172 104.802 15.5479 104.802 14.8779V12.0594C104.802 11.3895 104.732 11.3201 104.132 11.3201H94.7139V4.32015H104.917C105.586 4.32015 105.656 4.25083 105.656 3.58086V0.762392C105.656 0.0924256 105.586 0.0231018 104.917 0.0231018H90.9743C90.2818 0.0231018 90.1895 0.0924256 90.1895 0.762392V26.6139C90.1895 27.2838 90.2587 27.3531 90.9743 27.3531H105.056C105.748 27.3531 105.84 27.2838 105.84 26.6139V23.6799C105.817 23.1254 105.725 23.0561 105.032 23.0561Z"
        fill="currentColor"
      />
      <path
        d="M78.7164 8.10891C78.7164 2.24092 74.7229 0.0231018 68.8595 0.0231018H60.9648C60.3877 0.0231018 60.3877 0.0924256 60.3877 0.762392V26.6139C60.3877 27.2838 60.3877 27.3531 60.9648 27.3531H64.2196C64.9122 27.3531 64.9122 27.2838 64.9122 26.6139V16.3333H67.9592L73.3609 26.9373C73.5456 27.2838 73.7995 27.3762 74.0996 27.3762H77.8854C78.347 27.3762 78.4625 27.0297 78.2778 26.7063L72.6915 15.802C76.1079 15.0396 78.7164 12.5676 78.7164 8.10891ZM69.1827 12.3597H64.9122V4.29703H69.1827C72.0451 4.29703 74.1919 5.42905 74.1919 8.29374C74.1919 11.1584 72.022 12.3597 69.1827 12.3597Z"
        fill="currentColor"
      />
    </svg>
  )
}
